// removed by extract-text-webpack-plugin
module.exports = {"itemContainer":"itemContainer__115nn","contentWrap":"contentWrap__1uoqa","titleStyle":"titleStyle__1-bMv","descriptionStyle":"descriptionStyle__1ZLnm","imgWrap":"imgWrap__XZrc6","priceGroupWrap":"priceGroupWrap__gcuxS","btnWrap":"btnWrap__31fui","pricetStyle":"pricetStyle__1QEdc"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/E-Book/styles.css
// module id = 1495
// module chunks = 0